/* 
  File JS per maviva-region-service. 
  L'animazione è stata spostata integralmente in CSS Puro (Keyframes) per garantire 
  la comparsa istantanea e sicura del blocco al caricamento della pagina, evitando 
  invisibilità causate dall'editor di Shopify o da latenze di rete.
  Questo file viene mantenuto per compatibilità strutturale.
*/

document.addEventListener('DOMContentLoaded', () => {
  // Pronto per eventuali interazioni custom
});